import { apiConfig } from "./apiConfig";

const commentPostUrl = apiConfig.oftheday.comment;

export const postComment = (axios, payload) => axios.post(`${commentPostUrl}`, payload);
